import { Component } from '@theme/component'
import { ThemeEvents } from '@theme/events'
import { morph } from '@theme/morph'

const ProductPriceConfig = {
  selectors: {
    price: '[id^="Price-"]'
  }
}

class ProductPrice extends Component {
  #handleVariantUpdate = (event) => {
    if (event.detail.data.productId !== this.dataset.productId) return

    const newHtml = event.detail.data.html
    const newPriceSource = newHtml.querySelector(
      ProductPriceConfig.selectors.price
    )
    const currentPriceTarget = this.querySelector(
      ProductPriceConfig.selectors.price
    )

    if (newPriceSource && currentPriceTarget) {
      morph(currentPriceTarget, newPriceSource)
    }
  }

  connectedCallback() {
    super.connectedCallback()
    window.addEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    )
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener(
      ThemeEvents.variantUpdate,
      this.#handleVariantUpdate
    )
  }
}

customElements.define('product-price', ProductPrice)
